/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {abandonPOSCheckIn} from '../api'

export const useMutationAbandonPOSCheckIn = createReactQueryMutationHook('abandonPOSCheckIn', abandonPOSCheckIn)
